export const IeSmoothScrollModule = angular
    .module('app.directives.ieSmoothScroll', [])
    .directive('ieSmoothScroll', ($window) => {
        return {
            link: () => {
                // IE smooth scrolling fix
                if ($window.navigator.userAgent.match(/MSIE 10/i) ||
                    $window.navigator.userAgent.match(/Trident\/7\./) ||
                    $window.navigator.userAgent.match(/Edge\/12\./)) {
                    angular.element('body').on('mousewheel', () => {
                        $window.event.preventDefault();
                        var wd = $window.event.wheelDelta;
                        var csp = $window.pageYOffset;
                        $window.scrollTo(0, csp - wd);
                    });
                }
            }
        };
    }).name;


// WEBPACK FOOTER //
// ./src/app/directives/ieSmoothScroll.directive.js